import React from 'react'
import { RouteComponentProps } from 'react-router'
import { IPageRenderConfig, IAutoRefresh, IDateRange, IKeyValue } from '@fareye/types'
import { ISelecetedFilters, ISummaryData } from '../../utility/types'
import { useTimer } from '@fareye/common'
import MultiModalTable from './listingComponents/MultiModalTable'


interface IMultiModalTripListing extends RouteComponentProps, IAutoRefresh {
  config: IPageRenderConfig
  pageType: IKeyValue<string>,
  setSummaryData: React.Dispatch<React.SetStateAction<ISummaryData>>,
  selectedFilters: ISelecetedFilters
}

const MultiModalTripListing: React.FC<IMultiModalTripListing> = (props) => {
  const { maxRefreshCount, refreshInterval, config } = props
  const { minAutoRefreshInterval } = config?.config || {}
  const [timer] = useTimer({
    maxRefreshCount,
    refreshInterval,
    minAutoRefreshInterval
  })
  return <MultiModalTable {...{...props, config: config}} timer={timer} />
}

export default MultiModalTripListing